import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class InactivityAPI extends ComponentAPI {
    /**
     * Returns the button theme.
     */
    getBackToLoginButtonTheme() {
        return this.state.backToLoginButtonTheme;
    }
    /**
     * Updates the current button theme.
     *
     * @param backToLoginButtonTheme - The new button theme.
     */
    setBackToLoginButtonTheme(backToLoginButtonTheme) {
        this.setState({ backToLoginButtonTheme });
    }
    /**
     * Returns the button expression.
     */
    getBackToLoginExpression() {
        return this.state.backToLoginExpression;
    }
    /**
     * Updates the current button expression.
     *
     * @param backToLoginExpression - The new button expression.
     */
    setBackToLoginExpression(backToLoginExpression) {
        this.setState({ backToLoginExpression });
    }
    /**
     * Returns the message expression.
     */
    getMessageExpression() {
        return this.state.messageExpression;
    }
    /**
     * Updates the current message expression.
     *
     * @param messageExpression - The new message expression.
     */
    setMessageExpression(messageExpression) {
        this.setState({ messageExpression });
    }
    /**
     * Returns the title expression.
     */
    getTitleExpression() {
        return this.state.titleExpression;
    }
    /**
     * Updates the current title expression.
     *
     * @param titleExpression - The new title expression.
     */
    setTitleExpression(titleExpression) {
        this.setState({ titleExpression });
    }
}
export { InactivityAPI, };
//# sourceMappingURL=inactivity-api.js.map